import { DraftOrder } from '../../types/orders';

export enum ActionTypes {
    GetDraftOrder = '[draftOrder] GET_DRAFT_ORDER',
    DraftOrderResponse = '[draftOrder] FETCH_DRAFT_ORDER_RESPONSE',
    DraftOrderNotFoundResponse = '[draftOrder] DRAFT_ORDER_NOT_FOUND',
}

export interface GetDraftOrder {
    type: ActionTypes.GetDraftOrder;
    payload: {
        accountId: string;
        id: string;
    };
}

export interface DraftOrderResponse {
    type: ActionTypes.DraftOrderResponse;
    payload: {
        draft: DraftOrder;
    };
    meta: {
        cause: GetDraftOrder;
    };
}

export interface DraftOrderNotFoundResponse {
    type: ActionTypes.DraftOrderNotFoundResponse;
    meta: {
        cause: GetDraftOrder;
    };
}

export function getDraftOrder(accountId: string, id: string): GetDraftOrder {
    return {
        type: ActionTypes.GetDraftOrder,
        payload: {
            id,
            accountId,
        },
    };
}

export type Actions = GetDraftOrder | DraftOrderResponse | DraftOrderNotFoundResponse;
